import React from "react";
import { withRouter } from "react-router-dom";
import { ITEM_TABS } from "./ItemTabsConfig";

const ReusableItemTabs = (props) => {
    
    const {
        match,
        history,
        activeTab: propActiveTab,
        onChangeTab,
        itemId: propItemId,
        category,
        allowedTabs = null,
        extraProps = {},
        useRouting = true
    } = props;

    // Determine if routing should be used
    const hasRouting = useRouting && match && match.params;

    // Determine active tab
    const activeTab = hasRouting
        ? (match.params.tab || "details")
        : (propActiveTab || "details");

    // Determine item ID
    const itemId = hasRouting
        ? match.params.id
        : propItemId;

    // Get all tab keys
    let allTabKeys = Object.keys(ITEM_TABS);
    
    // Filter out inventory tab if category is 'service'
    if (category === 'services') {
        allTabKeys = allTabKeys.filter(key => key !== 'inventory');
    }
    
    // Filter out invalid tab keys based on allowedTabs
    const tabsToRender = allowedTabs && allowedTabs.length > 0
        ? allowedTabs.filter(key => allTabKeys.includes(key) && ITEM_TABS[key])
        : allTabKeys;

    const ActiveComponent = activeTab && ITEM_TABS[activeTab]?.component;

    const handleTabChange = (tabKey) => {
        if (hasRouting) {
            // Get current search params
            const searchParams = new URLSearchParams(props.location?.search);
            const itemName = searchParams.get('item_name') || extraProps?.itemName || '';
            const itemCode = searchParams.get('item_code') || '';
            const category = searchParams.get('category') || extraProps?.category || '';

            let obj = {
                item_name: itemName,
                item_code: itemCode,
                category: category
            };

            history.push({
                pathname: `/item_list/${tabKey}/${itemId}`,
                search: "?" + new URLSearchParams(obj).toString()
            });
        } else if (onChangeTab) {
            onChangeTab(tabKey);
        }
    };

    return (
        <div className="row ml1">
            <div className="col-12 pl0 bg-white">
                <ul className="nav nav-tabs">
                    {tabsToRender.map((key) => {
                        const tabConfig = ITEM_TABS[key];
                        if (!tabConfig) {
                            return null;
                        }
                        return (
                            <li key={key} className="nav-item">
                                <button
                                    type="button"
                                    className={`nav-link ${activeTab === key ? "active" : ""}`}
                                    onClick={() => handleTabChange(key)}
                                >
                                    {tabConfig.label}
                                </button>
                            </li>
                        );
                    })}
                </ul>

                <div className="tab-content ">
                    <div className="page_containt">
                        <div className="pageTbl">
                            <React.Suspense fallback={<div>Loading Tab...</div>}>
                                {ActiveComponent && (
                                    <ActiveComponent
                                        item_enc_id={itemId}
                                         
                                        category={category || extraProps?.category}
                                         onRefreshComplete={extraProps?.onRefreshComplete}
                                        {...extraProps}
                                    />
                                )}
                            </React.Suspense>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(ReusableItemTabs);